import React from 'react'
import { Switch, Route } from 'react-router-dom'
import Loadable from 'src/utils/loadable'

const routes = () => {
  return (
    <Switch>
      <Route path='/documents/vehicle' component={Loadable(() => import('./Vehicle'))} />
      <Route path='/documents/driver' component={Loadable(() => import('./Driver'))} />
      {/* @todo design is missing, need to redesign this screen  */}
      <Route path='/documents/mail-pinkslip' component={Loadable(() => import('./MailPinkSlip'))} />
      <Route path='/documents/item' component={Loadable(() => import('./DocumentView'))} />
      <Route
        path='/documents/policy-summary'
        component={Loadable(() => import('./PolicySummaryView'))}
      />
      <Route path='/documents/create-slip' component={Loadable(() => import('./CreateSlip'))} />
      {/* @todo design is missing, need to redesign this screen  */}
      <Route path='/documents/consent/:referer' component={Loadable(() => import('./Consent'))} />
      <Route path='/documents/slips' component={Loadable(() => import('./AllSlips'))} />
      <Route path='/documents/policies' component={Loadable(() => import('./AllPolicies'))} />
      <Route path='/documents/all' component={Loadable(() => import('./AllDocuments'))} />
      <Route path='/documents' component={Loadable(() => import('./MyDocuments.container'))} />
    </Switch>
  )
}

export default routes
